import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCogs, faHandsHelping } from "@fortawesome/free-solid-svg-icons";
import { UiConfig } from "../Config";
import { ContactFormLink } from "../help/ContactFormLink";
import { ContainerWithHeaderAndMenu } from "../menuandheader/ContainerWithHeaderAndMenu";
import { useTranslation, Trans } from "react-i18next";

export function InfoContact() {
  const { t } = useTranslation();

  return (
    <ContainerWithHeaderAndMenu
      icon={faHandsHelping}
      title={t("infoContact.title")}
    >
      <h5>
        <FontAwesomeIcon icon={faHandsHelping} />
        {t("infoContact.contactTitle")}
      </h5>
      <p>
        <Trans
          i18nKey="infoContact.contactDesc"
          components={{ contactFormLink: <ContactFormLink /> }}
        />
      </p>

      <h5>
        <FontAwesomeIcon icon={faCogs} />
        {t("infoContact.versionTitle")}
      </h5>
      <p>
        {t("infoContact.versionText")}
        {UiConfig.appVersion}
      </p>
    </ContainerWithHeaderAndMenu>
  );
}
